<div class="trainer-show-results-container">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading">
    <div class="loading-spinner"></div>
    <span>Loading trainer and show results...</span>
  </div>

  <!-- Error State -->
  <div *ngIf="error" class="error">
    {{ error }}
  </div>

  <!-- Main Content -->
  <div *ngIf="!isLoading && !error" class="results-content">
    <!-- Header Section -->
    <div class="page-header">
      <div class="header-content">
        <div class="header-title">
          <div class="trainer-show-info">
            <h1>{{ trainerInfo?.name }} {{ trainerInfo?.lastname }} Results</h1>
            <div class="show-tag">{{ showInfo?.nombre || 'Show' }}</div>
          </div>
          <p class="header-subtitle">Competition Results</p>
        </div>
        <div class="header-stats">
          <div class="stat-box">
            <span class="stat-value">{{ totalEntries }}</span>
            <span class="stat-label">Total Entries</span>
          </div>
          <div class="stat-box">
            <span class="stat-value">{{ wins }}</span>
            <span class="stat-label">Wins</span>
          </div>
          <div class="stat-box">
            <span class="stat-value">{{ podiums }}</span>
            <span class="stat-label">Podiums</span>
          </div>
          <div class="stat-box" *ngIf="totalEntries > 0">
            <span class="stat-value">{{ (wins / totalEntries * 100).toFixed(1) }}%</span>
            <span class="stat-label">Win Rate</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Results Table -->
         <div class="results-table-container">
       <div class="table-header">
         <h2>Results ({{ filteredResults.length }})</h2>
         <button class="download-csv-btn" (click)="downloadCSV()" [disabled]="filteredResults.length === 0">
           <i class="download-icon">📥</i>
           Download CSV
         </button>
       </div>
      
      <div class="table-responsive">
        <table class="results-table">
          <thead>
            <tr>
              <th (click)="sortResults('date')" class="sortable-header" [class.active]="sortColumn === 'date'">
                Date
                <span class="sort-icon" *ngIf="sortColumn === 'date'" [class.asc]="sortDirection === 'asc'" [class.desc]="sortDirection === 'desc'"></span>
              </th>
                             <th (click)="sortResults('class')" class="sortable-header" [class.active]="sortColumn === 'class'">
                 Class
                 <span class="sort-icon" *ngIf="sortColumn === 'class'" [class.asc]="sortDirection === 'asc'" [class.desc]="sortDirection === 'desc'"></span>
               </th>
               <th (click)="sortResults('rank')" class="sortable-header" [class.active]="sortColumn === 'rank'">
                 Rank
                 <span class="sort-icon" *ngIf="sortColumn === 'rank'" [class.asc]="sortDirection === 'asc'" [class.desc]="sortDirection === 'desc'"></span>
               </th>
               <th (click)="sortResults('rider')" class="sortable-header" [class.active]="sortColumn === 'rider'">
                 Rider
                 <span class="sort-icon" *ngIf="sortColumn === 'rider'" [class.asc]="sortDirection === 'asc'" [class.desc]="sortDirection === 'desc'"></span>
               </th>
               <th>Entry #</th>
               <th (click)="sortResults('horse')" class="sortable-header" [class.active]="sortColumn === 'horse'">
                 Horse
                 <span class="sort-icon" *ngIf="sortColumn === 'horse'" [class.asc]="sortDirection === 'asc'" [class.desc]="sortDirection === 'desc'"></span>
               </th>
               <th (click)="sortResults('owner')" class="sortable-header" [class.active]="sortColumn === 'owner'">
                 Owner
                 <span class="sort-icon" *ngIf="sortColumn === 'owner'" [class.asc]="sortDirection === 'asc'" [class.desc]="sortDirection === 'desc'"></span>
               </th>
               <th>Entries</th>
              <th>Result</th>
              <th>Prize</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let result of filteredResults">
              <td class="date-cell">
                {{ formatDate(result.inicio) }}
              </td>
                             <td class="class-cell">
                 <a [href]="'/competition/' + prefix + result.showId + '/' + prefix + result.competitionId" target="_blank">
                   {{ result.className }}
                   <span class="height-badge" *ngIf="result.height">{{ result.height }}</span>
                 </a>
               </td>
               <td class="rank-cell">
                 <span class="rank-badge"
                   [ngClass]="{
                     'rank-first': result.rank == '1',
                     'rank-second': result.rank == '2',
                     'rank-third': result.rank == '3',
                     'rank-top10': result.rank > '3' && result.rank <= '10',
                     'rank-other': result.rank > '10'
                   }">
                   {{ result.rank || '-' }}
                 </span>
               </td>
               <td class="rider-cell">
                 <a [href]="'/rider-profile/' + prefix + result.riderId" target="_blank" class="rider-link">
                   {{ result.riderName }}
                 </a>
               </td>
               <td class="entry-cell">
                 {{ result.entryNumber || result.number }}
               </td>
               <td class="horse-cell">
                 <a [href]="'/horse-profile/' + prefix + result.horseId" target="_blank" class="horse-link">
                   {{ result.horseName || result.horse }}
                 </a>
               </td>
               <td class="owner-cell">
                 {{ result.owner || '-' }}
               </td>
               <td class="entries-count-cell">
                 {{ getEntryCount(result) }}
               </td>
              <td class="result-cell">
                <div class="result-details">
                  <div *ngIf="result.result1">{{ result.result1 != '0.00' ? result.result1 : '-' }}</div>
                  <div *ngIf="result.result2" class="result-secondary">{{ result.result2 != '0.000' ? result.result2 : '-' }}</div>
                </div>
              </td>
              <td class="prize-cell">
                {{ result.prize || '-' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- No Results State -->
      <div *ngIf="filteredResults.length === 0" class="no-results">
        <div class="no-results-icon">🏆</div>
        <h3>No Results Found</h3>
        <p>No competition results found for this trainer at this show.</p>
      </div>
    </div>
  </div>
</div> 